<div class="book" *ngIf="imgSrc">
  <div class="book__wrapper">
    <img class="book__cover" [src]="imgSrc"/>
  </div>
</div>
